<template>
  <div
    :class="[
      'sf-virtual-table__data-row-cell',
      'tw-w-full',
      {
        'sf-virtual-table__data-row-cell--sticky': isSticky,
        'sf-virtual-table__data-row-cell--sticky-last': isLastStickyColumn,
      },
    ]"
    :style="stickyStyle"
    data-testid="sf-virtual-table-data-cell"
  >
    <slot />
  </div>
</template>

<script setup lang="ts">
import { toRef } from 'vue'
import { useStickyColumn } from '@app/shared/vue/composables/use-sticky-column'

interface Props {
  columnIndex?: number | null
}

const props = withDefaults(defineProps<Props>(), {
  columnIndex: null,
})

const { isSticky, isLastStickyColumn, stickyStyle } = useStickyColumn({
  columnIndex: toRef(props, 'columnIndex'),
})
</script>

<style lang="scss" scoped>
@import 'silverfin-ui-kit/src/scss/tooling';

.sf-virtual-table__data-row-cell {
  // The hover color rides the row-level variable so the cell under the cursor
  // matches the row tint instead of the mixin's default snow-light.
  @include table-data-cell(
    (
      background-color: transparent,
      background-color-hover: var(--sf-virtual-table-row-bg, white),
    )
  );

  border-top-style: none;
  border-left-style: none;

  &--sticky {
    background-color: var(--sf-virtual-table-row-bg, white);
    will-change: transform;
    backface-visibility: hidden;
  }

  &--sticky-last {
    border-right: 1px solid theme('colors.sf-slate.subtle-2');
  }
}
</style>
